import { UserManager, WebStorageStateStore, Log } from 'oidc-client-ts';
import { stripTrailingSlash } from './utils';

export default {
  UserManager: null,
  configureUserManager: function (config) {
    const storage = new WebStorageStateStore({ store: window.sessionStorage });
    /* To enable oidc-client internal logging
     *  pass in OIDC_LOGGING level or boolean
     *  LEVEL: NONE = 0, ERROR = 1, WARN = 2, INFO = 3, DEBUG = 4;
     */
    if (config.OIDC_LOGGING) {
      Log.setLogger(console);
      Log.setLevel(
        [Log.ERROR, Log.WARN, Log.INFO, Log.DEBUG].includes(config.OIDC_LOGGING) ? config.OIDC_LOGGING : Log.WARN
      );
    }

    const callbackUrl = `${window.location.origin}${window.location.pathname}`;
    const redirectUri = config['HOME_URL'] || stripTrailingSlash(callbackUrl);

    this.UserManager = new UserManager({
      authority: config['OIDC_AUTHORITY'],
      client_id: config['OIDC_CLIENT_ID'],
      redirect_uri: redirectUri,
      post_logout_redirect_uri: config['START_PAGE_URL'],
      response_type: 'code', //'token id_token',
      scope: 'openid profile email',
      loadUserInfo: false,
      automaticSilentRenew: true,
      silent_redirect_uri: config['SILENT_RENEW_URL'],
      stateStore: storage,
    });
  },
};
